import { createContext, useContext, type ReactNode } from 'react';

import { templateConfig, type TemplateConfig } from './template.config';

const TemplateConfigContext = createContext<TemplateConfig | null>(null);

export function CatEdgeConfigProvider({
  config,
  children,
}: {
  config: TemplateConfig;
  children: ReactNode;
}) {
  return <TemplateConfigContext.Provider value={config}>{children}</TemplateConfigContext.Provider>;
}

export function useTemplateConfig(): TemplateConfig {
  return useContext(TemplateConfigContext) ?? templateConfig;
}
